import { GUID, Param } from "app/brightserve/brightserve.module";

export class MedicalHistory {
    Id: GUID;
    Author: string;
    Created: Date;
    Text: string;
    Status: Param;

    constructor(init?: Partial<MedicalHistory>) {
        Object.assign(this, init);

        if (init && init.Status) {
            this.Status = new Param(init.Status);
        } else {
            this.Status = null;
        };
    }

    static BlankMedicalHistory(init?: any) {
        var medicalHistory = new MedicalHistory(init);
        medicalHistory.Id = GUID.newGuid();
        medicalHistory.Status = new Param();
        return medicalHistory;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/medical-history.ts